import {
  buildTestIds,
  descriptionParcelsText,
  formatCurrency,
  getMeasuredUnit,
  valueProduct,
} from "application";
import { Skeleton } from "components";
import { useCallback } from "react";
import { Price } from "typing";
import {
  DiscountTagContainer,
  DiscountTagDot,
  DiscountTagText,
  OldPrice,
  PriceValue,
  PriceValueDetail,
} from "ui";
import { ViewPaymentMethods } from "../ViewPaymentMethods";
import {
  BoxPriceProductContainer,
  DescriptionParcels,
  Margin4,
  View,
} from "./styles";

interface BoxPriceProductProps {
  packageCurrentState?: Price;
  measuredUnity?: string;
  modalViewMore?: boolean;
  notShouldShowOldPrice?: boolean;
  notShouldShowTagOff?: boolean;
  notShouldShowOldPriceAndDiscount?: boolean;
  fontSizePrice?: string;
  fontSizeDiscount?: string;
  fontSizeDescriptionParcels?: string;
  marginBottomPrice?: boolean;
  installmentsIsVisibled?: boolean;
  maxWidth?: string;
  fontSizeDetailsValue?: string;
  flexDirectionTextDescount?: string;
  shouldShowTextSpotPriceOnHeaderFixedMobile?: boolean;
  isBlackFriday?: boolean;
  descriptionParcelsFontColor?: string;
}

const BoxPriceProduct = ({
  packageCurrentState,
  measuredUnity,
  modalViewMore = true,
  fontSizeDiscount,
  fontSizeDescriptionParcels,
  fontSizePrice,
  marginBottomPrice,
  maxWidth,
  installmentsIsVisibled = true,
  fontSizeDetailsValue,
  notShouldShowOldPrice,
  notShouldShowOldPriceAndDiscount = false,
  notShouldShowTagOff,
  shouldShowTextSpotPriceOnHeaderFixedMobile,
  isBlackFriday,
  descriptionParcelsFontColor,
}: BoxPriceProductProps) => {
  const priceProduct = valueProduct(packageCurrentState as Price);

  const renderDetailsValue = useCallback(() => {
    if (
      packageCurrentState?.spotPrice &&
      packageCurrentState?.spotPrice <= packageCurrentState?.salePrice
    ) {
      return shouldShowTextSpotPriceOnHeaderFixedMobile
        ? "à vista"
        : "à vista no pix ou no cartão";
    }

    if (measuredUnity) {
      return getMeasuredUnit(measuredUnity);
    }

    return "";
  }, [
    measuredUnity,
    packageCurrentState?.salePrice,
    packageCurrentState?.spotPrice,
    shouldShowTextSpotPriceOnHeaderFixedMobile,
  ]);

  if (!priceProduct) {
    return <Skeleton count={1} width={170} />;
  }

  const returnOldPriceAndDiscount = () => {
    return (
      <>
        {packageCurrentState?.priceList !== packageCurrentState?.salePrice && (
          <OldPrice
            {...buildTestIds("box-price-product-old-price")}
            notShouldShowOldPrice={notShouldShowOldPrice}
            fontSizeDiscount={fontSizeDiscount}
          >
            {formatCurrency(packageCurrentState?.priceList || 0)}
          </OldPrice>
        )}

        {!notShouldShowTagOff &&
          packageCurrentState?.discountPercentage !== "0" && (
            <DiscountTagContainer
              {...buildTestIds("box-price-product-discount-tag-container")}
            >
              <DiscountTagDot
                {...buildTestIds("box-price-product-discount-tag-dot")}
              />
              <DiscountTagText
                {...buildTestIds("box-price-product-discount-tag")}
                fontSizeDiscount={fontSizeDiscount}
              >
                {packageCurrentState?.discountPercentage}% OFF
              </DiscountTagText>
            </DiscountTagContainer>
          )}
      </>
    );
  };

  return (
    <BoxPriceProductContainer
      removeGap={shouldShowTextSpotPriceOnHeaderFixedMobile}
      {...buildTestIds("box-price-product-container")}
    >
      {notShouldShowOldPriceAndDiscount ? null : (
        <View notShouldShowOldPrice={notShouldShowOldPrice}>
          {returnOldPriceAndDiscount()}
        </View>
      )}
      <PriceValue
        isBlackTheme={!!isBlackFriday}
        {...buildTestIds("box-price-product-price-value")}
        isFlexDirectionColumn={!!packageCurrentState?.spotPrice}
        fontSize={fontSizePrice}
      >
        {formatCurrency(priceProduct || 0)}
        <PriceValueDetail
          {...buildTestIds("box-price-product-price-value-detail")}
          isBlackTheme={isBlackFriday}
          fontSize={fontSizeDetailsValue}
        >
          {renderDetailsValue()}
        </PriceValueDetail>
      </PriceValue>
      {(installmentsIsVisibled &&
        packageCurrentState?.maxNumberInstallments &&
        packageCurrentState?.maxNumberInstallments > 1 && (
          <>
            <DescriptionParcels
              fontColor={descriptionParcelsFontColor}
              isBlackTheme={isBlackFriday}
              {...buildTestIds("box-price-product-description-parcels")}
              maxWidth={maxWidth}
              fontSizeDescriptionParcels={fontSizeDescriptionParcels}
            >
              {descriptionParcelsText({
                maxNumberInstallments:
                  packageCurrentState?.maxNumberInstallments,
                salePrice: packageCurrentState?.salePrice,
                spotPrice: packageCurrentState?.spotPrice,
              })}
            </DescriptionParcels>
            {modalViewMore && (
              <ViewPaymentMethods
                {...buildTestIds("box-price-product-view-more-components")}
                {...packageCurrentState}
              />
            )}
          </>
        )) ||
        (marginBottomPrice && (
          <Margin4 {...buildTestIds("box-price-product-margin-bottom-price")} />
        ))}
    </BoxPriceProductContainer>
  );
};

export default BoxPriceProduct;
